import { Component } from '@angular/core';

@Component({
  selector: 'app-blank-page',
  templateUrl: './blank-page.component.html',
  styleUrls: ['./blank-page.component.scss'],
  standalone: false
})
export class BlankPageComponent {
  websiteUrl = 'https://aieventzo.com/';

  navigateToHome(): void {
    window.location.href = this.websiteUrl;
  }
}
